import React from "react";
import {Redirect, Route} from "react-router-dom";
import {connect} from "react-redux";

const PrivateRoute = ({component: Component, user, ...rest}) => (
    <Route
        {...rest}
        render={props => {
            return user !== null ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: {from: props.location}
                    }}
                />
            )
        }

        }
    />
);

export default connect(
    state => ({
        user: state.app.user
    })
)(PrivateRoute)


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js